export default {
  id: 'PrintSchedule',
  code: 'CN',
  text: {
    'Print Class Schedule': '课表打印',
    'Choose Type': '选择课表',
    'Weekly': '周课表',
    'Daily': '日课表',
    'Display Options': '显示选项',
    'Print': '打印',
    'Show Lesson Name': '显示课节名称',
    'Show Teacher Name': '显示老师姓名',
    'Show Classroom': '显示教室',
    'Choose type:': '选择类型',
    'Display Options:': '展示设置',
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/PrintSchedule/locale.js